import axios from 'axios'

const buildUrl = (url) => process.env.REACT_APP_API_ROOT + url

const _getAccessToken = () => {
  return localStorage.getItem('accessToken')
}

export const _getRefreshToken = () => {
  return localStorage.getItem('refreshToken')
}

const PrivateAPI = {
  get: (url, query) => {
    return axios({
      method: 'get',
      url: buildUrl(url),
      headers: {
        'Authorization': 'Bearer ' + _getAccessToken()
      }
    })
  },

  post: (url, payload) => {
    return axios({
      method: 'post',
      url: buildUrl(url),
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + _getAccessToken()
      }
    })
  },

  delete: (url, payload) => {
    return axios({
      method: 'delete',
      url: buildUrl(url),
      data: payload,
      headers: {
        'Authorization': 'Bearer ' + _getAccessToken()
      }
    })
  }
}

export default PrivateAPI
